import React, { useState, useEffect } from "react";
import _ from "lodash";
import StateAttestationActionRequired from "../StateAttestationsModal/Components/ActionRequired";
import Notice from "../Notice";
import Http from "../StateAttestationsModal/http";
import PharmCertDrawComponent from "../PharmacyCertification/Index";
import SubmissionDetailsCard from "./SubmissionDetailsCard";
import SubmissionModal from "../common/SubmissionModal";
import EntityRegistrationCard from "./EntityRegistrationCard";

const Draw = (props) => {
  const [attestationStats, setAttestationStats] = useState({});
  const [attestations, setAttestations] = useState([]);
  const [displayModal, setDisplayModal] = useState(false);
  const [notice, setNotice] = useState({
    kind: "error",
    open: false,
    message: "",
  });

  useEffect(() => {
    if (props.controller == "entities") {
      Http.fetchEntityAttestations(
        props.organizationID,
        props.entity.id,
        setAttestations,
        setNotice
      );
    }
    if (props.controller == "dashboard") {
      Http.fetchOrgAttestations(props.organizationID, setAttestations, setNotice);
    }
  }, []);

  useEffect(() => {
    if (props.controller == "entities") {
      Http.getEntityStats(props.organizationID, props.entity.id, setAttestationStats, setNotice);
    }
    if (props.controller == "dashboard") {
      Http.getOrgStats(props.organizationID, setAttestationStats, setNotice);
    }
  }, [attestations]);

  const renderActionRequired = () => {
    if (!attestationStats || Object.keys(attestationStats).length == 0) {
      return null;
    }

    return _.map(attestationStats, (policyStats, policy) => {
      if (policy == "sanofi_anti-diversion_attestations") {
        return (
          <div key={policy} className="draw__item__container">
            <StateAttestationActionRequired
              page={props.controller}
              policy={policy}
              organizationID={props.organizationID}
              entity={props.entity}
              entities={props.entities}
              userName={props.userName}
              setNotice={setNotice}
              stats={policyStats}
              setStats={setAttestationStats}
              attestations={attestations}
              setAttestations={setAttestations}
            />
          </div>
        );
      }
    });
  };

  const renderSubmissionModal = () => {
    if (!displayModal) {
      return null;
    }

    return (
      <SubmissionModal
        organizationId={props.organizationID}
        handleCloseModal={() => setDisplayModal(false)}
      />
    );
  };

  function renderPharmCertDrawComponent() {
    // Pharm Cert Component is scoped to org – don't show on entity profile which is scoped to entity.
    if (props.controller !== "entities") {
      return (
        <PharmCertDrawComponent
          organizationId={props.organizationID}
          entities={props.entities}
          setNotice={setNotice}
        />
      );
    }

    return null;
  }

  return (
    <div>
      <div className="draw__item__container">
        <SubmissionDetailsCard
          organization={props.organizationID}
          atRisk={props.atRisk}
          entity={props.entity}
          transferDetails={props.transfer_details}
          setDisplayModal={setDisplayModal}
        />
      </div>

      <EntityRegistrationCard
        registrations={props.pendingRegistrations}
        setNotice={setNotice}
        organizationID={props.organizationID}
      />

      {renderPharmCertDrawComponent()}

      {renderActionRequired()}

      {renderSubmissionModal()}

      <Notice details={notice} />
    </div>
  );
};

export default Draw;
